export interface WizardHeaderProps {
  eyebrow?: string
  heading: string
  subheading?: string
  text?: string
}

const WizardHeader = ({
  eyebrow,
  heading,
  subheading,
  text,
}: WizardHeaderProps) => (
  <div
    className="container w-[752px] max-w-full flex flex-col gap-6 px-5 lg:px-10"
    data-testid="wizard-header"
  >
    <div>
      {eyebrow ? <p className="text-overline mb-2">{eyebrow}</p> : null}

      <h1 className="text-3xl font-display font-medium leading-[124%] tracking-[0.6px]">
        {heading}
      </h1>

      {subheading ? (
        <h2 className="text-charcoal-500 text-lg font-medium leading-[140%] tracking-[0.36px] mt-6">
          {subheading}
        </h2>
      ) : null}

      {text ? (
        <p className="text-dusk-700 font-body leading-[140%] tracking-[0.32px] mt-4">
          {text}
        </p>
      ) : null}
    </div>
  </div>
)

export default WizardHeader
